import { toNumber } from '@/libs/utils/'
import { defineRule } from '../define-rule'
import { assertNotNullish, assertPrimitives } from '@/libs/utils/assertion.util'
import type { BaseRuleConstructorParams } from '../ts/rule-constructor-parameter.type'

export type MinRuleConstructorParams = BaseRuleConstructorParams<{ min: number }>

export const min = defineRule('min', ({ config, errorMessage }: MinRuleConstructorParams) => {
  const { min } = config
  assertNotNullish(min)
  return (value) => {
    assertPrimitives(value, 'string', 'number')
    return toNumber(value as string | number) >= min || (errorMessage ?? false)
  }
})
